var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 51,
    viewBox: "0 0 125 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M111.778 26.4788C109.861 26.4788 108.051 26.9095 106.432 27.6683C106.571 27.0428 106.645 26.3967 106.645 25.7302C106.645 20.5618 102.301 16.3778 96.9338 16.3778C94.7402 16.3778 92.717 17.0854 91.0877 18.275C87.9358 10.6454 80.2156 5.25138 71.1643 5.25138C67.0433 5.25138 63.1992 6.36915 59.9407 8.30731C58.8013 3.80546 54.6058 0.452148 49.5797 0.452148C44.1809 0.452148 39.7404 4.30794 39.0163 9.31227C37.813 9.07641 36.5671 8.95335 35.2893 8.95335C24.875 8.95335 16.4307 17.0854 16.4307 27.1146C16.4307 27.9862 16.5159 28.8374 16.6437 29.6783C16.0474 29.3809 15.3872 29.1963 14.6631 29.1963C12.2884 29.1963 10.361 31.0421 10.3291 33.3187C9.84991 33.2469 9.37073 33.1956 8.87024 33.1956C3.97191 33.1956 0 37.0207 0 41.7379C0 46.4551 3.97191 50.2801 8.87024 50.2801H111.778C118.604 50.2801 124.141 44.9476 124.141 38.3743C124.141 31.8113 118.604 26.4788 111.778 26.4788Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCloud);
export default __webpack_public_path__ + "static/media/Left Cloud.849788b7caf7e66d9ed9aa58e62aeb60.svg";
export { ForwardRef as ReactComponent };